import React from "react";
import IProjectProps from "./interfaces/IProjectProps";

const Project = ({
  index,
  title,
  domain,
  description,
  tags,
  imagestr,
  imageCaption,
}: IProjectProps) => (
  <article className="project">
    <span className="project-index">{index}</span>
    <div className={`project-main${imagestr ? " has-image" : ""}`}>
      <div>
        <div className="project-title-row">
          <h3>{title}</h3>
          <span className="project-domain">{domain}</span>
        </div>
        <p className="project-description">{description}</p>
        <ul className="tag-list">
          {tags.map((tag) => (
            <li key={tag}>{tag}</li>
          ))}
        </ul>
      </div>
      {imagestr && (
        <figure className="project-figure">
          <img src={imagestr} alt={title} />
          {imageCaption && <figcaption>{imageCaption}</figcaption>}
        </figure>
      )}
    </div>
  </article>
);

export default Project;
